import { QUERY_INPUT_TYPES } from 'utils/constants'
import strings from 'utils/strings'

const {
  DIGITAL_INPUT,
  CARRY,
  NATIVE_INPUT,
  CAN_INPUT,
  ANALOG_INPUT,
  SWITCH_INPUT,
} = QUERY_INPUT_TYPES

export const inputTypes = (disabled) => [
  {
    text: strings.native,
    value: NATIVE_INPUT,
    disabled: disabled[NATIVE_INPUT],
  },
  {
    text: strings.switch_input_type_label,
    value: SWITCH_INPUT,
    disabled: disabled[SWITCH_INPUT],
  },
  {
    text: strings.digital_pin_input,
    value: DIGITAL_INPUT,
    disabled: disabled[DIGITAL_INPUT],
  },
  {
    text: strings.analog_pin_input,
    value: ANALOG_INPUT,
    disabled: disabled[ANALOG_INPUT],
  },

  {
    text: strings.can,
    value: CAN_INPUT,
    disabled: disabled[CAN_INPUT] || false,
  },
  {
    text: strings.carry_input,
    value: CARRY,
    disabled: disabled[CARRY],
  },
]
